import {MessageService} from '../../services/message.service';
import {Component, OnInit} from '@angular/core';
import {Ship} from '../../Ship';
import {EntitlementService} from '../../services/entitlement.service';
import {ShipService} from '../../services/ship.service';
import {Router} from '@angular/router';
import {CardTypes} from '../../data/static/CardTypes';
import { BulkCardOrder } from '../../data/BulkCardOrder';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {quantityValidator} from '../../validators/ship-validator';
import {ShipClassBulkCardOrderLimit} from '../../data/ShipClassBulkCardOrderLimit';
import {ShipsContact} from "../../data/ShipsContact";
import {ModalComponent} from "../../modal/modal.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ShipRosterIdentity} from "../../data/ShipRosterIdentity";

@Component({
  selector: 'app-bulk-cards',
  templateUrl: './bulk-cards.component.html',
  styleUrls: ['./bulk-cards.component.css']
})
export class BulkCardsComponent implements OnInit {
  ship: Ship;
  shipResultArray: Ship[];
  bulkCardOrders: BulkCardOrder[];
  activate_cardholders_btn = false;
  order_replacementCards_btn = false;
  order_repCards_btn_spinner: string;
  save_ac_btn_spinner: string;
  save_oc_btn_spinner: string;
  cardTypeArray = new CardTypes();
  bulkCardType: string;
  bulkCardQty: string;
  confirmMode = false;
  bulkVisitorCardForm: UntypedFormGroup;
  shipClassBulkCardOrderLimit: ShipClassBulkCardOrderLimit;
  shipsContact: ShipsContact;
  rosterSize: number;
  page = 1;
  pageSize = 25;

  constructor(
    private entitlementService: EntitlementService,
    private shipService: ShipService,
    private router: Router,
    private modalService: NgbModal,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.ship = this.shipService.retrieveShipProfile();
    this.shipResultArray = this.shipService.retieveAllShipProfileResults();
    if (this.ship == null) {
      this.router.navigate(['/shipProfiles']);
    }
    this.shipService.getShipBulkCardOrders(this.ship.shipLocation).subscribe(
      (data: BulkCardOrder[]) => {
          this.bulkCardOrders = data;
      },
      error =>
        console.log('There was an error retrieving bulk card orders: ' + error)
    );
    this.shipService.getShipClassBulkCardOrderLimits().subscribe(
      (data: ShipClassBulkCardOrderLimit) => {
        this.shipClassBulkCardOrderLimit = data;
      },
      error => {
        this.messageService.error('Error getting bulk card order limits');
        console.log('There was an error retrieving bulk card order limits: ' + error);
      }
    );
    this.shipService.getShipContacts(this.ship.shipLocation).subscribe(
      (data: ShipsContact) => {
        this.shipsContact = data;
      },
      (error) => {
        console.log('Error getting ship contact: ' + error);
      }
    );
    this.shipService.getShipRoster(this.ship.shipLocation).subscribe(
      (data: ShipRosterIdentity[]) => {
        this.rosterSize = data.length;
      }
    )
    this.initForm();
  }

  initForm() {
    this.bulkVisitorCardForm = new UntypedFormGroup({
      type: new UntypedFormControl(this.cardTypeArray.getCardArray()[0], [
        Validators.required
      ]),
      quantity: new UntypedFormControl(null, [Validators.required, quantityValidator])
    });
    this.bulkCardType = this.cardTypeArray.getCardArray()[0].value;
    this.bulkVisitorCardForm.patchValue({type: this.bulkCardType});
  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  onShipChange(newShip: Ship) {
    this.ship = newShip;
    this.shipService.storeShipProfile(this.ship);
  }

  setColumnStatus(columnValue) {
    let columnDisplay = 'transactionHistText';

    if (
      columnValue === 'B' ||
      columnValue === 'N' ||
      columnValue === 'P' ||
      columnValue === 'X'
    ) {
      columnDisplay = 'transactionHistNeg';
    } else if (
      columnValue === 'E' ||
      columnValue === 'I' ||
      columnValue === 'K' ||
      columnValue === 'U'
    ) {
      columnDisplay = 'bulkOrderStatusRed';
    } else if (
      columnValue === 'A' ||
      columnValue === 'C' ||
      columnValue === 'S' ||
      columnValue === 'Z'
    ) {
      columnDisplay = 'transactionHistPos';
    } else if (columnValue === 'D') {
      columnDisplay = 'transactionHistText';
    }

    return columnDisplay;
  }

  setOrderStatus(columnValue) {
    let columnDisplay = 'transactionHistText';

    if (
      columnValue === 'GD_SHIPPED' ||
      columnValue === 'GD_RECEIVED' ||
      columnValue === 'GD PROCESSED'
    ) {
      columnDisplay = 'transactionHistNeg';
    } else if (
      columnValue === 'CANCELED' ||
      columnValue === 'ERROR'
    ) {
      columnDisplay = 'bulkOrderStatusRed';
    } else if (
      columnValue === 'CREATED' ||
      columnValue === 'READY FOR GD' ||
      columnValue === 'COMPLETE'
    ) {
      columnDisplay = 'transactionHistPos';
    }
    return columnDisplay;
  }

  activateCardholders() {
    this.activate_cardholders_btn = true;
    this.save_ac_btn_spinner = 'fa fa-spinner fa-spin';

    this.shipService.activateBulkCordholder(this.ship.shipLocation).subscribe(
      (data: BulkCardOrder[]) => {
        this.bulkCardOrders = data;
        this.messageService.success('Activated successfully');
        this.activate_cardholders_btn = false;
      },
      error => {
        console.log(error.error);

        this.activate_cardholders_btn = false;
        this.messageService.error(error.error);
        this.save_ac_btn_spinner = '';
      },
      () => {
        this.save_ac_btn_spinner = '';
      }
    );
  }

  onOrderClick() {
    this.save_oc_btn_spinner = 'fa fa-spinner fa-spin';

    if (this.bulkCardType === "emvbulk") {
      if (this.shipsContact.emvBulkAddress == null && this.shipsContact.address == null) {
        this.onOrderError("Bulk and Shipping Address is required to submit an EMV Card Order.")
      } else if (this.shipsContact.emvBulkAddress == null) {
        this.onOrderError("Bulk Mailing Address is required to submit an EMV Card Order.")
      } else if (this.shipsContact.address == null) {
        this.onOrderError("Shipping Address is required to submit an EMV Card Order.")
      } else {
        this.orderBulkCards();
      }
    } else if (this.bulkCardType === "emvvisitor") {
      if (this.shipsContact.emvBulkAddress == null && this.shipsContact.address == null) {
        this.onOrderError("Bulk and Shipping Address is required to submit an EMV Visitor Card Order.")
      } else if (this.shipsContact.emvBulkAddress == null) {
        this.onOrderError("Bulk Mailing Address is required to submit an EMV Visitor Card Order.")
      } else if (this.shipsContact.address == null) {
        this.onOrderError("Shipping Address is required to submit an EMV Visitor Card Order.")
      } else {
        this.orderBulkCards();
      }
    } else {
      this.orderBulkCards();
    }
  }

  orderBulkCards() {
    this.shipService.postBulkCardOrders(
      this.ship.shipLocation,
      this.bulkCardType,
      this.bulkVisitorCardForm.value['quantity']
    ).subscribe(
      (data: BulkCardOrder[]) => {
        this.bulkCardOrders = data;
        this.bulkVisitorCardForm.reset();
        this.bulkVisitorCardForm.patchValue({type: this.bulkCardType});
        this.confirmMode = false;
        this.messageService.success('Ordered successfully');
      },
      error => {
        this.onOrderError(error.error);
      },
      () => {
        this.save_oc_btn_spinner = '';
      }
    );
  }

  onOrderError(errorMessage: string) {
    this.confirmMode = false;
    this.messageService.error(errorMessage);
    this.save_ac_btn_spinner = '';
  }

  onConfirmClick() {
    // If the card type is 'visitor' there are no card limit checks
    if (this.bulkCardType !== this.cardTypeArray.getCardArray()[1].value) {
      const cardOrderAmount = parseInt(this.bulkVisitorCardForm.value['quantity'], 10);
      // ensure ship class is not null and lowercase
      const shipClass = this.ship.shipClass ? this.ship.shipClass.toLowerCase() : '';
      // Return the limit retrieved from the database. If the ship class is ""/null (i.e. camps) or doesn't exist
      // set the default limit to the default 500
      const cardOrderLimit = this.shipClassBulkCardOrderLimit.hasOwnProperty(shipClass) ?
        this.shipClassBulkCardOrderLimit[shipClass] : this.shipClassBulkCardOrderLimit.defaultLimit;
      if (cardOrderAmount == null) {
        this.messageService.error('Error getting card order amount');
        return;
      }
      if (cardOrderAmount <= 0 || cardOrderAmount > cardOrderLimit) {
        this.messageService.error(`${cardOrderAmount} Cards can not be ordered at this time for ship: /n
        ${this.ship.shipName}. Minimum 1 to Maximum ${cardOrderLimit} cards can be ordered for this ship in one request`);
        return;
      }
    }
    this.confirmMode = !this.confirmMode;
  }

  setCardType(cardType: string) {
    this.bulkCardType =
      cardType === null ? this.cardTypeArray.getCardArray()[0].value : cardType;

    this.shipService.getShipBulkCardOrders(this.ship.shipLocation).subscribe(
      (data: BulkCardOrder[]) => {
        this.bulkCardOrders = data;
      },
      error =>
        console.log('There was an error retrieving bulk card orders: ' + error)
    );
  }

  orderReplacementCardsByLocation() {
    const modalRef = this.modalService.open(ModalComponent);
    const modalInstance = modalRef.componentInstance as ModalComponent;
    modalInstance.modalTitle = 'Confirm Replacement';
    modalInstance.modalBody = 'Please confirm you would like to recard the entire ship of ' + this.rosterSize + ' Cardholders?';
    modalInstance.modalOkButtonText = 'Order';
    modalInstance.modalCancelButtonText = 'Cancel';
    modalRef.result.then(() => {
        this.order_replacementCards_btn = true;
        this.order_repCards_btn_spinner = 'fa fa-spinner fa-spin';

        this.shipService.orderReplacementCardsByLocation(this.ship.shipLocation).subscribe(
          response => {
            this.messageService.success('Replacement Cards Ordered successfully.');
            this.order_replacementCards_btn = false;
            this.order_repCards_btn_spinner = '';
          },
          errorResp => {
            if (errorResp.status === 200 && errorResp.error.text === 'Order replacement card Successful.') {
              this.messageService.success('Replacement Cards Ordered successfully.');
            } else {
              this.messageService.error('Replacement Card Ordered Failed.');
            }
            this.order_replacementCards_btn = false;
            this.order_repCards_btn_spinner = '';
          }
        );
      },
      () => {
        return;
      });
  }

  cancelOrders(dateCreatedFormatted, type, pinMailerFlag, batchUUID) {
    this.shipService
    .postBulkCardCancel(this.ship.shipLocation, type, dateCreatedFormatted, pinMailerFlag, batchUUID)
    .subscribe((data: BulkCardOrder[]) => (this.bulkCardOrders = data));
  }

  isRosterSizeUndefined() {
    return this.rosterSize === undefined;
  }

  identify(index, item) {
    return item.label;
  }
}
